var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendario = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 3.32648C2.8731 3.32648 2.5 3.7184 2.5 4.20187V14.0062C2.5 14.4897 2.8731 14.8816 3.33333 14.8816H12.6667C13.1269 14.8816 13.5 14.4897 13.5 14.0062V4.20187C13.5 3.7184 13.1269 3.32648 12.6667 3.32648H3.33333ZM1.5 4.20187C1.5 3.13825 2.32081 2.27601 3.33333 2.27601H12.6667C13.6792 2.27601 14.5 3.13825 14.5 4.20187V14.0062C14.5 15.0698 13.6792 15.9321 12.6667 15.9321H3.33333C2.32081 15.9321 1.5 15.0698 1.5 14.0062V4.20187Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6665 0.875389C10.9426 0.875389 11.1665 1.11054 11.1665 1.40062V4.20187C11.1665 4.49194 10.9426 4.7271 10.6665 4.7271C10.3904 4.7271 10.1665 4.49194 10.1665 4.20187V1.40062C10.1665 1.11054 10.3904 0.875389 10.6665 0.875389Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 0.875389C5.60964 0.875389 5.8335 1.11054 5.8335 1.40062V4.20187C5.8335 4.49194 5.60964 4.7271 5.3335 4.7271C5.05735 4.7271 4.8335 4.49194 4.8335 4.20187V1.40062C4.8335 1.11054 5.05735 0.875389 5.3335 0.875389Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 7.00311C1.5 6.71303 1.72386 6.47788 2 6.47788H14C14.2761 6.47788 14.5 6.71303 14.5 7.00311C14.5 7.29319 14.2761 7.52834 14 7.52834H2C1.72386 7.52834 1.5 7.29319 1.5 7.00311Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendario, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/calendario.d4bd0661.svg";
export { ForwardRef as ReactComponent };